import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import BusinessCampus from '../pages/business/campus';
import BusinessCampusCreate from '../pages/business/campus/create';
import BusinessCampusEdit from '../pages/business/campus/edit';
import BusinessCoupon from '../pages/business/coupon';
import BusinessCouponCreate from '../pages/business/coupon/create';
import BusinessCouponEdit from '../pages/business/coupon/edit';
import BusinessRegion from '../pages/business/region';
import BusinessSession from '../pages/business/session';
import BusinessSessionCreate from '../pages/business/session/create';
import BusinessSessionRead from '../pages/business/session/read';
import BusinessSessionEdit from '../pages/business/session/edit';
import BusinessSessionRegister from '../pages/business/session/register';
import BusinessInquiry from '../pages/business/inquiry';
import BusinessInquiryRead from '../pages/business/inquiry/read';

const BusinessRouter: FC = () => {
  return (
    <Switch>
      <Route path='/business/region' exact component={BusinessRegion} />
      <Route path='/business/inquiry' exact component={BusinessInquiry} />
      <Route path='/business/inquiry/:inquiryCode' exact component={BusinessInquiryRead} />
      <Route path='/business/session' exact component={BusinessSession} />
      <Route path='/business/session/create' exact component={BusinessSessionCreate} />
      <Route path='/business/session/:eventNo' exact component={BusinessSessionRead} />
      <Route path='/business/session/:eventNo/edit' exact component={BusinessSessionEdit} />
      <Route path='/business/session/:eventNo/register' exact component={BusinessSessionRegister} />
      <Route path='/business/coupon' exact component={BusinessCoupon} />
      <Route path='/business/coupon/create' exact component={BusinessCouponCreate} />
      <Route path='/business/coupon/:id/edit' exact component={BusinessCouponEdit} />
      <Route path='/business/campus' exact component={BusinessCampus} />
      <Route path='/business/campus/create' exact component={BusinessCampusCreate} />
      <Route path='/business/campus/:id/edit' exact component={BusinessCampusEdit} />
    </Switch>
  )
}

export default BusinessRouter;
